import PrebuiltBet from './_prebuilt-bet.js'
import FlexPane from './_flex-pane.js'
import Image from './_image.js'
import Text from './_text.js'
import DateTime from './_date-time.js'
import NeutralVenueIndicator from './_neutral-venue-indicator.js'

export default {
  name: 'PrebuiltBetBuilder',
  values: {
    view: {
      configSet: PrebuiltBet,
      configValues: {},
    },
    headerContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
      },
    },
    matchAccaIcon: {
      configSet: Image,
      configValues: {
        src: 'system-betbuilder',
        style: {
          flexGrow: 0,
          width: '12px',
          height: '16px',
        },
      },
    },
    headerTextContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          flexWrap: 'wrap',
        },
      },
    },
    eventName: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    timeAndTypeContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexWrap: 'wrap',
        },
      },
    },
    startTimeFormat: {
      configSet: DateTime,
      configValues: {
        showTodayAndTomorrowLabels: true,
      },
    },
    startTime: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    typeName: {
      configSet: Text,
      configValues: {},
    },
    neutralVenueIndicator: {
      configSet: NeutralVenueIndicator,
      configValues: {
        container: {
          style: {
            alignItems: 'flex-start',
            padding: '2px',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
